module.exports = __webpack_public_path__ + "static/Frank-c98da27a4dd2aa356c9514164b7b9c14.png";